export default "__VITE_ASSET__Brtt5aog__"